import { useState } from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

const culturalSignificances = [
	'Christian',
	'South East Asian',
	'Jewish',
	'Chinese',
	'Muslim',
	'European',
	'South',
	'American',
]

function CulturalSignificances({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const [other, setOther] = useState(false)

	const toggleSelect = (title) => {
		setOther(false)
		setWeddingData((prev) =>
			prev.culturalSignificances.includes(title)
				? {
						...weddingData,
						culturalSignificances:
							prev.culturalSignificances.filter(
								(t) => t !== title
							), // remove if already selected
					}
				: {
						...weddingData,
						culturalSignificances: [
							...prev.culturalSignificances,
							title,
						], // add if not selected
					}
		)
	}

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>
						Which cultural significances do you want to celebrate?
					</h2>
					<p style={{ marginTop: '5px' }}>Can select multiple</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '15px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{culturalSignificances.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData.culturalSignificances.includes(
													label
												)
													? '#7ca6bd'
													: '#FFF',
											color: weddingData.culturalSignificances.includes(
												label
											)
												? '#FFF'
												: '#7ca6bd',
										}}
										onClick={() => toggleSelect(label)}
									>
										{label}
									</ButtonCustom>
								))}
								<ButtonCustom
									variant="pilled"
									style={{
										backgroundColor: other
											? '#7ca6bd'
											: '#FFF',
										color: other ? '#FFF' : '#7ca6bd',
									}}
									onClick={() => {
										setOther(true)
										setWeddingData({
											...weddingData,
											culturalSignificances: [],
										})
									}}
								>
									Other
								</ButtonCustom>
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					onClick={() => {
						// const step = other ? 2 : 1

						if (!other && !weddingData.culturalSignificances.length)
							return toastHelper(
								'Please select at least one option',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.7} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default CulturalSignificances
